import AddressHash from '@/components/AddressHash'
import styles from './index.module.less'
import classNames from 'classnames'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { getFormatTimeZone } from '@/utils'
import useMeNavigate from '@/hooks/useMeNavigate'
import { useParams } from 'react-router-dom'
import { useGlobalStore } from '@/hoxStore/globalStore'
import { CheckinRecords_Record } from '@/api/account/interface'

const TransactionListCardInfo = ({
  cardData,
}: {
  address: string
  cardData: CheckinRecords_Record
}) => {
  const { curReponsive } = useGlobalStore()
  const navigate = useMeNavigate()
  const { timeUtc0 = '-', currentTime = '-' } = getFormatTimeZone(cardData?.check_in_time)
  const { t } = useTranslation()
  const params = useParams()

  const handleJump = useCallback(() => {
    if (params.address) {
      navigate(`/transaction/${cardData.transition_hash}?address=${params.address}&net_type=rollup`)
    } else {
      navigate(`/transaction/${cardData.transition_hash}?net_type=rollup`)
    }
  }, [cardData])

  const getLeftKuohao = () => {
    if (curReponsive?.size === 'mobile') {
      return '('
    }
    return '（'
  }

  const getRightKuohao = () => {
    if (curReponsive?.size === 'mobile') {
      return ')'
    }
    return '）'
  }

  return (
    <div className={styles.wrap}>
      <div className="account_tx_area_a">
        <div className={styles.title}>hash</div>
        <div
          className={classNames({
            [styles.textStyleOne]: true,
            font_14: true,
          })}
        >
          <AddressHash
            data={cardData?.transition_hash}
            cutOption
            handleJump={handleJump}
          ></AddressHash>
        </div>
      </div>
      <div className="account_tx_area_b">
        {/* 状态 */}
        <div className={styles.title}>{t('explorer_53')}</div>
        <div
          className={classNames({
            [styles.textStyleTwo]: true,
            font_14: true,
          })}
        >
          <span>{t('explorer_25')}</span>
          <span
            className={classNames({
              [styles.successIcon]: true,
            })}
          ></span>
        </div>
      </div>
      <div className="account_tx_area_d">
        {/* 类型 */}
        <div className={styles.title}>{t('explorer_104')}</div>

        <div
          className={classNames({
            [styles.textStyleTwo]: true,
            [styles.textStyleTwoItemStart]: true,
            font_14: true,
          })}
        >
          <span className={styles.typeName}>{t('explorer_284')}</span>
        </div>
      </div>
      <div className="account_tx_area_e">
        {/* 数量 */}
        <div className={styles.title}>{t('explorer_105')}</div>
        <div
          className={classNames({
            [styles.textStyleTwo]: true,
            [styles.amount]: true,
            font_14: true,
          })}
        >
          <span
            className={classNames({
              [styles.textStyleThree]: true,
              font_14: true,
            })}
          >
            {'-'}
          </span>
        </div>
      </div>
      <div className="account_tx_area_f">
        {/* 区块 */}
        <div className={styles.title}>{t('explorer_3')}</div>
        <div
          className={classNames({
            [styles.textStyleTwo]: true,
            font_14: true,
          })}
        >
          <AddressHash data={cardData?.height as unknown as string}></AddressHash>
        </div>
      </div>

      <div className="account_tx_area_g">
        <div className={styles.title}>GasFee</div>
        <div
          className={classNames({
            [styles.textStyleTwo]: true,
            font_14: true,
          })}
        >
          <span>-</span>
        </div>
      </div>
      <div className="account_tx_area_h">
        {/* 时间戳 */}
        <div className={styles.title}>{t('explorer_92')}</div>
        <div
          className={classNames({
            [styles.textStyleFive]: true,
            font_14: true,
          })}
        >
          <div className="font_14">
            {timeUtc0}
            <span
              className={classNames({
                [styles.textStyleFour]: true,
                font_14: true,
              })}
            >
              {getLeftKuohao()}UTC+0{getRightKuohao()}
            </span>
          </div>
          <div
            className="font_14"
            style={{ marginTop: curReponsive?.size === 'mobile' ? '0px' : '4px' }}
          >
            {currentTime}
            <span
              className={classNames({
                [styles.textStyleFour]: true,
                font_14: true,
              })}
            >
              {getLeftKuohao()}
              {t('explorer_95')}
              {getRightKuohao()}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransactionListCardInfo
